//export class AppHelper {

//  //fetch(cb) {
//  //  const req = new XMLHttpRequest();
//  //  req.open('GET', `assets/data/appHelper.json`);
//  //  req.onload = () => {
//  //    cb(JSON.parse(req.response));
//  //  };
//  //  req.send();
//  //}

//  //local settings:
//  static SiteUrl: string = "http://localhost:4202/";
//  static FTPUrl: string = "http://localhost:13485/";
//  static BaseUrl: string = "http://localhost:13485/api/";
//  static SSOTokenUrl: string = "http://localhost:51719/token";
//  static SSOAccountUrl: string = "http://localhost:51719/api/Account/";
//  static SSO_RoleUrl: string = "http://localhost:51719/api/Role/";
//  static SSO_BranchUrl: string = "http://localhost:51719/api/Branch/";
//  static SSO_ResourceUrl: string = "http://localhost:51719/api/Resource/";
//  static SSO_PermissionUrl: string = "http://localhost:51719/api/Permission/";
//  static SSO_UserManagerUrl: string = "http://localhost:51719/api/UserManager/";
//  static SSO_DataSecurityUrl: string = "http://localhost:51719/api/DataSecurity/";
//  static Hebeh: string = "http://hebeh.sayeh.ir/api/object/";


//  ////server settings:
//  //static SiteUrl: string = "http://sayeh.ir/";
//  //static FTPUrl: string = 'http://services.sayeh.ir/';
//  //static BaseUrl: string = 'http://services.sayeh.ir/api/';
//  //static SSOTokenUrl: string = 'http://auth.sayeh.ir/token';
//  //static SSOAccountUrl: string = 'http://auth.sayeh.ir/api/Account/';
//  //static SSO_RoleUrl: string = 'http://auth.sayeh.ir/api/Role/';
//  //static SSO_BranchUrl: string = 'http://auth.sayeh.ir/api/Branch/';
//  //static SSO_ResourceUrl: string = 'http://auth.sayeh.ir/api/Resource/';
//  //static SSO_PermissionUrl: string = 'http://auth.sayeh.ir/api/Permission/';
//  //static SSO_UserManagerUrl: string = 'http://auth.sayeh.ir/api/UserManager/';
//  //static SSO_DataSecurityUrl: string = 'http://auth.sayeh.ir/api/DataSecurity/';
//  //static Hebeh: string = 'http://hebeh.sayeh.ir/api/object/';


//  ////server test settings:
//  //static SiteUrl: string = "http://test.sayeh.ir/";
//  //static FTPUrl: string = 'http://test.services.sayeh.ir/';
//  //static BaseUrl: string = 'http://test.services.sayeh.ir/api/';
//  //static SSOTokenUrl: string = 'http://test.auth.sayeh.ir/token';
//  //static SSOAccountUrl: string = 'http://test.auth.sayeh.ir/api/Account/';
//  //static SSO_RoleUrl: string = 'http://test.auth.sayeh.ir/api/Role/';
//  //static SSO_BranchUrl: string = 'http://test.auth.sayeh.ir/api/Branch/';
//  //static SSO_ResourceUrl: string = 'http://test.auth.sayeh.ir/api/Resource/';
//  //static SSO_PermissionUrl: string = 'http://test.auth.sayeh.ir/api/Permission/';
//  //static SSO_UserManagerUrl: string = 'http://test.auth.sayeh.ir/api/UserManager/';
//  //static SSO_DataSecurityUrl: string = 'http://test.auth.sayeh.ir/api/DataSecurity/';
//  //static Hebeh: string = 'http://hebeh.sayeh.ir/api/object/';


//  static appId: number = 1;
//  static mightyAppId: number = 3;
//  static myBranchId: number = 100;
//  static homeLayout: string = "home";
//  static adminLayout: string = "admin";
//}

export const AppHelper =
{
  SiteUrl: null,
  FTPUrl: null,
  BaseUrl: null,
  SSoBaseUrl: null,
  SSoApi: null,
  signalR_Url: null,
  Hebeh: null,

  appId: 1,
  guestUser: { id: '100100100-1000-1000-1000-10010010000', name: 'کاربر میهمان' },
  mightyAppId: 3,
  myBranchId: 100,
  homeLayout: 'home',
  adminLayout: 'admin',
  defaultCacheTimeoutSeconds: null,
  refreshTokens: false,
  tokenExpiryOffsetSeconds: 30, // assume the token is expired if its expiration time is due this amount of seconds
};
